<template>
  <div>
    <section class="back-section">
      <div class="back-section__container">
        <div class="text-right my-3">
          <button class="transparent-btn mr-3" @click="tempProductOpen(false)">
            新增
          </button>
          <!-- <button class="transparent-btn mr-3" @click="exportExcel()">
						匯出excel
					</button> -->
          <button class="transparent-btn mr-3" @click="delAll()">
            刪除全部
          </button>
          <button class="transparent-btn mr-3" @click="delSelected()">
            刪除已選
          </button>
        </div>
        <ag-grid-vue
          @grid-ready="onGridReady"
          @close="tempProductOpen"
          rowSelection="multiple"
          style="height: 500px;"
          class="ag-theme-alpine"
          enableSorting="true"
          enableFilter="true"
          enableColResize="true"
          pagination="true"
          paginationAutoPageSize="true"
          groupUseEntireRow="true"
          :rowData="rowData"
          :columnDefs="columnDefs"
          :localeText="localeText"
          :gridOptions="gridOptions"
        >
        </ag-grid-vue>
      </div>
    </section>
    <!-- vue component  -->
    <ProductForm
      :isclose="backFormIsClose"
      @close="tempProductOpen"
      :product-id="currentProductTempId"
      @refreshProducts="createRowData"
    ></ProductForm>
  </div>
</template>

<script>
import EditButton from '@/components/back/EditButton';
import ProductForm from './components/ProductForm';
import { mapState } from 'vuex';
export default {
  beforeMount() {
    // 初始化
    // 允許父通信 表格要加上:gridOptions="gridOptions"
    this.gridOptions = {
      context: {
        componentParent: this,
      },
    };
    // 中文化
    this.localeText = this.$localText;
    // 行資料
    this.createRowData();
    // 列資料
    this.createColumnDefs();
  },
  data() {
    return {
      backFormIsClose: true,
      products: [],
      currentProductTempId: null,
      //ag
      columnDefs: '',
      rowData: '',
      gridApi: null,
      columnApi: null,
      context: null,
      gridOptions: null,
      // 默認預言設定
      localeText: {},
    };
  },
  components: { EditButton, ProductForm },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  methods: {
    tempProductOpen(boolean, id) {
      this.currentProductTempId = id;
      this.backFormIsClose = boolean;
    },
    delHandler(arr) {
      arr.forEach(({ id }) => {
        const { url: apiDel } = new this.$adminUrl(
          false,
          this.user.uuid,
          this.user.apiPath,
          id,
        );
        this.axios.delete(apiDel);
      });
    },
    //-----------------------------------------------------------以下是ag功能
    exportExcel() {
      let selected = this.gridApi.getSelectedRows();
      this.gridApi.exportDataAsExcel(selected);
    },
    delAll() {
      this.$fire({
        title: '確定要刪除?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '是',
        cancelButtonText: '否',
      }).then(result => {
        if (result.value === true) {
          this.delHandler(this.rowData);
          this.gridApi.setRowData([]);
          return;
        }
      });
    },
    delSelected() {
      let selected = this.gridApi.getSelectedRows();
      this.delHandler(selected);
      this.gridApi.updateRowData({
        remove: selected,
      });
    },
    onGridReady(params) {
      // 獲取aggrid.api物件才能使用裡面的方法 例如自動縮放 單元格子獲取
      this.gridApi = params.api;
      // 忘了
      this.columnApi = params.columnApi;
      // 設定自動填滿
      this.gridApi.sizeColumnsToFit();
    },
    createRowData() {
      const { url: api } = new this.$adminUrl(
        true,
        this.user.uuid,
        this.user.apiPath,
      );
      //預設帶入 token
      this.axios.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      this.axios.get(api).then(response => {
        this.products = response.data.data;
        this.rowData = response.data.data;
      });
    },
    createColumnDefs() {
      // 表格要加上:columnDefs="columnDefs"
      this.columnDefs = [
        {
          headerName: '分類',
          field: 'category', // 單選
          // 可否單選
          checkboxSelection: true,
          // 可否全選
          headerCheckboxSelection: true,
          // 寬度預設平均分配
          // width: 100,
          minWidth: 100,
          // 可否編輯
          editable: true,
          // 分左右組 left center right
          pinned: 'left',
          menuTabs: ['filterMenuTab', 'columnsMenuTab'],
        },
        {
          headerName: 'id',
          field: 'id',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '標題',
          field: 'title',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '內容',
          field: 'content',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '單位',
          field: 'unit',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '是否啟用',
          field: 'enabled',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '原價',
          field: 'origin_price',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '特價',
          field: 'price',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '編輯',
          field: 'edit',
          minWidth: 200,
          colId: 'cube',
          cellRendererFramework: 'EditButton',
          menuTabs: ['filterMenuTab'],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
